var _circle, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoSolutionsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 38.5,
    r: 38.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.5158,
    y: 24.8171,
    width: 2.25483,
    height: 34.8804,
    rx: 1.12741,
    transform: "rotate(29.9682 46.5158 24.8171)",
    fill: "black",
    stroke: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5485 44.9648C37.3786 45.1348 37.0954 45.1348 36.9255 44.9648L33.3005 41.3398C33.1306 41.1699 33.1306 40.8867 33.3005 40.7168C33.4704 40.5469 33.7536 40.5469 33.9235 40.7168L37.2653 44.002L44.1755 37.0918C44.3454 36.9219 44.6286 36.9219 44.7985 37.0918C44.9685 37.2617 44.9685 37.5449 44.7985 37.7148L37.5485 44.9648ZM53.5778 41C53.5778 49.043 47.0642 55.5 39.0778 55.5C31.0349 55.5 24.5778 49.043 24.5778 41C24.5778 33.0137 31.0349 26.5 39.0778 26.5C47.0642 26.5 53.5778 33.0137 53.5778 41ZM39.0778 27.4062C31.5446 27.4062 25.4841 33.5234 25.4841 41C25.4841 48.5332 31.5446 54.5938 39.0778 54.5938C46.5544 54.5938 52.6716 48.5332 52.6716 41C52.6716 33.5234 46.5544 27.4062 39.0778 27.4062Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSolutionsIcon);
export default __webpack_public_path__ + "static/media/no-solutions-icon.f139751a753df8b0a126edef36094902.svg";
export { ForwardRef as ReactComponent };